export default "__VITE_ASSET__CG6hT0tJ__"